import React, { createContext, useState } from "react";

export const SlotContext = createContext();

export const SlotProvider = ({ children }) => {
  const [selectedSlot, setSelectedSlot] = useState("");

  return (
    <SlotContext.Provider value={{ selectedSlot, setSelectedSlot }}>
      {children}
    </SlotContext.Provider>
  );
};